import { FieldValues, useController, UseControllerProps } from "react-hook-form";
import { useTranslateZodError } from "../../utils/zod";
import { Checkbox, type CheckboxProps } from "@chakra-ui/react";

type ControlledCheckBoxProps<TFieldValues extends FieldValues> = CheckboxProps &
  UseControllerProps<TFieldValues> & {
    handleChange?: () => void;
  };

export function ControlledCheckBox<T extends FieldValues>({
  name,
  rules,
  shouldUnregister,
  defaultValue,
  control,
  handleChange,
  ...props
}: ControlledCheckBoxProps<T>) {
  const {
    field,
    fieldState: { invalid, error },
  } = useController({
    name,
    rules,
    shouldUnregister,
    defaultValue,
    control,
  });
  const translateError = useTranslateZodError();
  return (
    <Checkbox
      {...field}
      isChecked={field.value}
      onChange={() => {
        handleChange && handleChange();
        field.onChange(!field.value);
      }}
      errorMessage={translateError(error?.message || "")}
      isInvalid={invalid}
      {...props}
    />
  );
}
